let userAgent = navigator.userAgent
export default {
  isIE () {
    return (
      (userAgent.indexOf('compatible') > -1 &&
        userAgent.indexOf('MSIE') > -1) ||
      this.isIE11()
    )
  },
  isIE11 () {
    return (
      userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
    )
  }
}
